import './App.css';
import Topber from './components/Topbar'
// import TopCarousel from './components/TopCarousel'
import About from './components/About'
import Features from './components/Features'
import Price from './components/Price'
import ComProfile from './components/ComProfile'
import { 
  Grid
} from '@material-ui/core';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Topber />
      </header>
      <Grid container className="gridcont"
      style={{paddingTop: '150px'}}
      >
        {/* <Grid xs={12} className="grid">
          <TopCarousel />
        </Grid> */}

        <Grid xs={12} className="grid">
          <About />
        </Grid>

        <Grid xs={12} className="grid">
          <Features />
        </Grid>
        
        <Grid xs={12} className="grid">
          <Price />
        </Grid>

        <Grid xs={12} className="grid">
          <ComProfile />
        </Grid>
        <br />

      </Grid>
      
       

    </div>
  );
}

export default App;
